import Scene, { ISceneParams } from './Scene';
import Game from '../Game';
import RenderSystem from '../System/Render/RenderSystem';
import AnimationSystem from '../System/Animation/AnimationSystem';
import TimerSystem from '../System/Timer/TimerSystem';
import AudioSystem from 'System/Audio/AudioSystem';
import PlinkoSystem from 'System/Plinko/PlinkoSystem';
import PlinkoUISystem from 'System/UI/PlinkoUISystem';

export interface IPlinkoSceneParams extends ISceneParams {
    forceJackpot: boolean;
}
export default class PlinkoScene extends Scene {
    public params: IPlinkoSceneParams;

    public init(): void {
        this.addSystem(new TimerSystem(Game.store));
        this.addSystem(new PlinkoSystem(Game.store));
        this.addSystem(new PlinkoUISystem(Game.store));
        this.addSystem(new AnimationSystem(Game.store));
        this.addSystem(new RenderSystem(Game.store));
        this.addSystem(new AudioSystem(Game.store));

        this.systems.forEach(system => system.init());
    }
}
